import { render } from "./ModosDeJogo.vue?vue&type=template&id=cec60b08&scoped=true"
import script from "./ModosDeJogo.vue?vue&type=script&lang=js"
export * from "./ModosDeJogo.vue?vue&type=script&lang=js"

import "./ModosDeJogo.vue?vue&type=style&index=0&id=cec60b08&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cec60b08"]])

export default __exports__